

import { Component, Vue, Watch, Prop } from 'vue-property-decorator'


import {Form, FormItem} from 'kpc/components/form'
import Button, { ButtonGroup } from 'kpc/components/button';
import Tooltip from 'kpc/components/tooltip';


import * as billTypeService from '../../../services/kec/billType'
import * as docsService from '../../../services/common/docs'


const billTypeChangeEvent = 'billTypeChange'

@Component({
    components: {
        Form, FormItem,
        Button, ButtonGroup,
        Tooltip
    }
})
export default class BillTypeConfig extends Vue {

    // 传入计费方式列表
    @Prop({
        required: true
    })
    billTypeList:billTypeService.IBillType[][] = []

    // 传入选中的计费方式
    @Prop({
        required: true
    })
    billType:number = 0

    // 是否展示 查看计费说明 文案, 默认不展示
    @Prop({
        required: false
    })
    showBillTips:boolean = false

    // 内部选中的计费方式，与外部传入的隔离
    billTypeCheck:number = 5;


    billTypeService = billTypeService
    docsService = docsService


    @Watch('billType')
    billTypeWatcher(val:number) {
        if (this.billTypeCheck !== val) {
            this.billTypeCheck = val;
        }
    }

    @Watch('billTypeCheck')
    billTypeCheckWatcher(val:number) {
        if (this.billType !== val) {
            // 内部选择计费方式，通过事件向上传递
            this.$emit(billTypeChangeEvent, val);
        }
    }
}

